var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tagShow.length>0)?_c('div',{staticClass:"inline-flex minw80"},_vm._l((_vm.tagShow),function(item,index){return _c('img',{key:index,staticClass:"w80 inline-flex pr10",class:_vm.needTop ? (_vm.len>1 ? 'mt10' : 'mt8') : 'mt8',attrs:{"src":_vm.getImageUrl(item.image ? item.image : '')}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }